import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("common-dialog", {
    attrs: {
      "is-open": _vm.isOpen,
      "header-text": _vm.$t("workPackages.copyOf", {
        workpackageName: _vm.options.source.description,
      }),
      "ok-btn-text": _vm.$t("actions.confirmCopy"),
      "ok-btn-disabled": !_vm.isValid,
    },
    on: { onOk: _vm.emitOk, onCancel: _vm.emitCancel },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              VRow,
              { attrs: { "no-gutters": "" } },
              [
                _c(
                  VCol,
                  { attrs: { cols: "12" } },
                  [
                    _c(VTextField, {
                      attrs: {
                        label: _vm.$t("workPackages.enterWorkpackageName"),
                        rules: [_vm.valueRequired],
                      },
                      model: {
                        value: _vm.targetWorkpackage.description,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.targetWorkpackage,
                            "description",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "targetWorkpackage.description",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              VRow,
              [
                _c(
                  "feature-toggle",
                  { attrs: { toggle: "enableReferenceDate" } },
                  [
                    _c(
                      VCol,
                      { staticClass: "pt-0 pb-0", attrs: { cols: "6" } },
                      [
                        _c(
                          VMenu,
                          {
                            attrs: {
                              "close-on-content-click": false,
                              "nudge-right": 5,
                              transition: "scale-transition",
                              "offset-y": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      VTextField,
                                      _vm._g(
                                        {
                                          attrs: {
                                            value: _vm.computedReferenceDate,
                                            label: _vm.$t(
                                              "workPackages.referenceDate"
                                            ),
                                            disabled: _vm.isExactCopy,
                                            "append-icon": "event",
                                            readonly: "",
                                            clearable: "",
                                          },
                                          on: {
                                            "click:append": function ($event) {
                                              _vm.referenceDatePicker = true
                                            },
                                            "click:clear": function ($event) {
                                              _vm.targetWorkpackage.referenceDate =
                                                null
                                            },
                                          },
                                        },
                                        on
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.referenceDatePicker,
                              callback: function ($$v) {
                                _vm.referenceDatePicker = $$v
                              },
                              expression: "referenceDatePicker",
                            },
                          },
                          [
                            _vm._v(" "),
                            _c(VDatePicker, {
                              attrs: {
                                "first-day-of-week":
                                  _vm.i18nconfig.firstDayOfTheWeek,
                                locale: _vm.i18nconfig.fallbackLocale,
                                min: _vm.sixMonthsAgo,
                                max: _vm.todaysDate,
                              },
                              on: {
                                input: function ($event) {
                                  _vm.referenceDatePicker = false
                                },
                              },
                              model: {
                                value: _vm.targetWorkpackage.referenceDate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.targetWorkpackage,
                                    "referenceDate",
                                    $$v
                                  )
                                },
                                expression: "targetWorkpackage.referenceDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  VCol,
                  { staticClass: "pt-0 pb-0", attrs: { cols: "6" } },
                  [
                    _c(
                      VMenu,
                      {
                        attrs: {
                          "close-on-content-click": false,
                          "nudge-right": 5,
                          transition: "scale-transition",
                          "offset-y": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  VTextField,
                                  _vm._g(
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "workPackages.completionDate"
                                        ),
                                        disabled: _vm.isExactCopy,
                                        "append-icon": "event",
                                        readonly: "",
                                      },
                                      on: {
                                        "click:append": function ($event) {
                                          _vm.completionDatePicker = true
                                        },
                                      },
                                      model: {
                                        value: _vm.computedCompletionDate,
                                        callback: function ($$v) {
                                          _vm.computedCompletionDate = $$v
                                        },
                                        expression: "computedCompletionDate",
                                      },
                                    },
                                    on
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.completionDatePicker,
                          callback: function ($$v) {
                            _vm.completionDatePicker = $$v
                          },
                          expression: "completionDatePicker",
                        },
                      },
                      [
                        _vm._v(" "),
                        _c(VDatePicker, {
                          attrs: {
                            "first-day-of-week":
                              _vm.i18nconfig.firstDayOfTheWeek,
                            locale: _vm.i18nconfig.fallbackLocale,
                          },
                          on: {
                            input: function ($event) {
                              _vm.completionDatePicker = false
                            },
                          },
                          model: {
                            value: _vm.targetWorkpackage.completionDate,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.targetWorkpackage,
                                "completionDate",
                                $$v
                              )
                            },
                            expression: "targetWorkpackage.completionDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  VCol,
                  { staticClass: "pt-0 pb-0", attrs: { cols: "6" } },
                  [
                    _c(
                      VMenu,
                      {
                        attrs: {
                          "close-on-content-click": false,
                          "nudge-right": 5,
                          transition: "scale-transition",
                          "offset-y": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  VTextField,
                                  _vm._g(
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "workPackages.goLiveDate"
                                        ),
                                        "append-icon": "event",
                                        readonly: "",
                                      },
                                      on: {
                                        "click:append": function ($event) {
                                          _vm.goLiveDatePicker = true
                                        },
                                      },
                                      model: {
                                        value: _vm.computedGoLiveDate,
                                        callback: function ($$v) {
                                          _vm.computedGoLiveDate = $$v
                                        },
                                        expression: "computedGoLiveDate",
                                      },
                                    },
                                    on
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.goLiveDatePicker,
                          callback: function ($$v) {
                            _vm.goLiveDatePicker = $$v
                          },
                          expression: "goLiveDatePicker",
                        },
                      },
                      [
                        _vm._v(" "),
                        _c(VDatePicker, {
                          attrs: {
                            "first-day-of-week":
                              _vm.i18nconfig.firstDayOfTheWeek,
                            locale: _vm.i18nconfig.fallbackLocale,
                          },
                          on: {
                            input: function ($event) {
                              return _vm.onGoLiveDateInput()
                            },
                          },
                          model: {
                            value: _vm.targetWorkpackage.goLiveDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.targetWorkpackage, "goLiveDate", $$v)
                            },
                            expression: "targetWorkpackage.goLiveDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("cost-threshold-inputs", {
              attrs: {
                workpackage: _vm.targetWorkpackage,
                disabled: _vm.isExactCopy,
              },
              on: {
                "validation-change": function ($event) {
                  _vm.hasThresholdValidationError = $event
                },
              },
            }),
            _vm._v(" "),
            _c(
              "feature-toggle",
              { attrs: { toggle: "enableWorkpackagePeriodTypes" } },
              [
                _c(
                  VRow,
                  { attrs: { "no-gutters": "" } },
                  [
                    _c(
                      VCol,
                      { attrs: { cols: "6" } },
                      [
                        _c(VSelect, {
                          attrs: {
                            items: _vm.workpackagePeriodTypeItems,
                            label: `${_vm.$t(
                              "workPackages.workpackagePeriodType"
                            )} *`,
                            rules: [_vm.valueRequired],
                            disabled: _vm.isExactCopy,
                            "item-text": "text",
                            "item-value": "value",
                          },
                          model: {
                            value: _vm.targetWorkpackage.workpackagePeriodType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.targetWorkpackage,
                                "workpackagePeriodType",
                                $$v
                              )
                            },
                            expression:
                              "targetWorkpackage.workpackagePeriodType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "feature-toggle",
              { attrs: { toggle: "enableAOExtracts" } },
              [
                _c(
                  VRow,
                  { attrs: { "no-gutters": "" } },
                  [
                    _c(
                      VCol,
                      { attrs: { cols: "12" } },
                      [
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("workPackages.aoExtracts"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          VRadioGroup,
                          {
                            attrs: {
                              disabled: _vm.isExactCopy,
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.options.reuseExistingAOExtracts,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.options,
                                  "reuseExistingAOExtracts",
                                  $$v
                                )
                              },
                              expression: "options.reuseExistingAOExtracts",
                            },
                          },
                          [
                            _c(VRadio, {
                              attrs: {
                                value: true,
                                label: _vm.$t(
                                  "workPackages.aoExtractsSelection.copyFromExisting"
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c(VRadio, {
                              attrs: {
                                value: false,
                                label: _vm.$t(
                                  "workPackages.aoExtractsSelection.selectNewSource"
                                ),
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.options.reuseExistingAOExtracts
                  ? _c(
                      VRow,
                      { attrs: { "no-gutters": "" } },
                      [
                        _c(VCol, { attrs: { cols: "12" } }, [
                          _c(
                            "div",
                            { staticClass: "ao-extracts" },
                            [
                              _c(VAutocomplete, {
                                attrs: {
                                  items: _vm.aoExtractsOptions,
                                  multiple: "",
                                  dense: "",
                                  "item-text": "displayName",
                                  "item-value": "auditCorrelationId",
                                  rules: [_vm.aoExtractsRules],
                                },
                                model: {
                                  value: _vm.options.selectedAOExtracts,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.options,
                                      "selectedAOExtracts",
                                      $$v
                                    )
                                  },
                                  expression: "options.selectedAOExtracts",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "feature-toggle",
                                {
                                  attrs: { toggle: "usePeriodIdsInAOExtracts" },
                                },
                                [
                                  _vm.options.selectedAOExtracts.length > 0
                                    ? [
                                        _c("div", { staticClass: "mb-2" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "workPackages.associatedPeriodIds"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getAssociatedPeriodIds(
                                                _vm.options.selectedAOExtracts
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("exact-copy-toggle", {
              attrs: {
                "is-exact-copy": _vm.isExactCopy,
                disabled: !_vm.goLiveDatesMatch,
              },
              on: {
                change: function ($event) {
                  _vm.userDisabledExactCopy = !$event
                },
              },
            }),
            _vm._v(" "),
            _c("optimise-prices-toggle", {
              attrs: { "force-disabled": _vm.isExactCopy },
            }),
            _vm._v(" "),
            _c("refresh-on-create-toggle", {
              attrs: { "force-disabled": _vm.isExactCopy },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }